dealershipModule.factory("DealerPreferences", ['dealershipModuleConstants', '$sce', function(dealershipModuleConstants, $sce) {

    // This is one of several settings models.  The model name is plural, unlike the other settings
    // This is a constructor
    var DealerPreferences = function () {
        this.productCode = '';
        this.displayProfitAndCost = '';  // ALWAYS/NEVER/RIGHT_CLICK
        this.allowModifyRetail = '';     // true/false as string
        this.termSortOrder = '';         // ASC/DESC
        this.coverageSortOrder = '';     // ASC/DESC
        this.defaultDeductible = '';     // Code (not display value) from list of default deductible choices
        this.defaultCoverage = '';
        this.selectedSurcharges = [];
        this.includeDefaultProposal = 'false';
    };

    DealerPreferences.prototype.convertForBusinessServices= function()
    {
        return {
            "ProductCode": this.productCode,
            "CanRetailPriceBeModified": this.allowModifyRetail === 'true',
            "CoverageSortMode": this.coverageSortOrder,
            "DeductibleSortMode": null,
            "DefaultCoverage": this.defaultCoverage,
            "DefaultDeductible": this.defaultDeductible,
            "DisplayProfitCostMode": this.displayProfitAndCost,
            "EndDate": null,
            "SortedCoverages": null,
            "SortedDeductibles": null,
            "StartDate": null,
            "TermSortMode": this.termSortOrder,
            "DefaultSurcharges": this.selectedSurcharges,
            "IncludeInDefaultProposal" : this.includeDefaultProposal === 'true'
        }
    };


    DealerPreferences.prototype.toDisplayString = function () {
        var result = [];
        var joinRef = $sce.trustAsHtml('<br/>');
        if (this.displayProfitAndCost)
            result.push("Display Profit & Cost: " + this.displayProfitAndCost);

        if (this.allowModifyRetail === 'true' || this.allowModifyRetail === 'false')
            result.push("Price Modification: " + (this.allowModifyRetail === 'true' ? "Yes" : "No"));

        if (this.defaultCoverage)
            result.push("Choice Coverage: " + this.defaultCoverage);

        if (this.defaultDeductible)
            result.push("Choice Deductible: $" + this.defaultDeductible);

        return result.join(joinRef);
    };

    // This is a "static" method, intentionally not in prototype.
    DealerPreferences.createFromBusinessServices = function (data) {
        if (data) {
            var settings = new DealerPreferences();
            settings.productCode = data.ProductCode || "";
            settings.displayProfitAndCost = (data.DisplayProfitCostMode || "").toUpperCase();
            settings.allowModifyRetail = (!!data.CanRetailPriceBeModified).toString();
            settings.termSortOrder = (data.TermSortMode || "").toUpperCase();
            settings.coverageSortOrder = (data.CoverageSortMode || "").toUpperCase();  // currently not editable
            settings.defaultDeductible = data.DefaultDeductible;
            settings.defaultCoverage = data.DefaultCoverage;
            settings.includeDefaultProposal = (!!data.IncludeInDefaultProposal).toString();
            return settings;
        } else {
            return null;
        }
    };

    DealerPreferences.createBusinessServicesDefault = function () {

        var bsPrefs = {
            "ProductCode": dealershipModuleConstants.DEFAULT_PRODUCT,
            "CanRetailPriceBeModified": true,
            "CoverageSortMode": "ASC",
            "DeductibleSortMode": "ASC",
            "DefaultCoverage": "",
            "DefaultDeductible": "",
            "DisplayProfitCostMode": "ALWAYS",
            "EndDate": null,
            "SortedCoverages": null,
            "SortedDeductibles": null,
            "StartDate": null,
            "TermSortMode": "ASC",
            "DefaultSurcharges": [],
            "IncludeInDefaultProposal" : false
        };

        return bsPrefs;

    }

    return DealerPreferences;
}]);
